<template>
  <div>
    <div v-if="loading" class="tableContainerDetails">
      <div class="item-title-bold no-margin no-padding"></div>
      <f7-row class="card-body">
        <f7-col class="col-medium-width">
          <f7-row>
            <f7-col>
              <div class="label-strong">
                {{ this.$t('offerCode') }}
              </div>
              <div class="item-title-bold value-text">
                <div>
                  {{ OfferSummary.CodPresupuesto }}
                </div>
              </div>
            </f7-col>
          </f7-row>
        </f7-col>

        <f7-col class="col-min-width">
          <f7-row>
            <f7-col>
              <div class="label-strong">{{ this.$t('version') }}</div>
              <div class="item-title-bold value-text">
                {{ OfferSummary.Version }}
              </div>
            </f7-col>
          </f7-row>
        </f7-col>

        <f7-col class="col-min-width">
          <f7-row>
            <f7-col>
              <div class="label-strong">
                {{ this.$t('clientCode') }}
              </div>
              <div class="item-title-bold value-text">
                {{ OfferSummaryV2.CodCliente }}
              </div>
            </f7-col>
          </f7-row>
        </f7-col>

        <f7-col>
          <f7-row>
            <f7-col>
              <div class="label-strong">
                {{ this.$t('agronomySample.summary.client') }}
              </div>
              <div class="item-title-bold value-text">
                {{ OfferSummaryV2.RazonSocial }}
              </div>
            </f7-col>
          </f7-row>
        </f7-col>
      </f7-row>

      <f7-row class="card-body">
        <f7-col>
          <f7-row>
            <f7-col>
              <div class="label-strong">
                {{ this.$t('address') }}
              </div>
              <div class="item-title-bold value-text">
                {{ OfferSummaryV3.CodPostal }},
                {{ OfferSummaryV3.Ciudad }},
                {{ OfferSummaryV3.LineaDireccion1 }}
              </div>
            </f7-col>
          </f7-row>
        </f7-col>

        <f7-col class="col-min-width">
          <f7-row>
            <f7-col>
              <div class="label-strong">NIF</div>
              <div class="item-title-bold value-text">
                {{ OfferSummaryV2.IdentificacionFiscal }}
              </div>
            </f7-col>
          </f7-row>
        </f7-col>

        <f7-col>
          <f7-row>
            <f7-col>
              <div class="label-strong">
                {{ this.$t('contacts') }}
              </div>
              <div class="item-title-bold value-text">
                {{ OfferSummaryV4.Email }}
              </div>
            </f7-col>
          </f7-row>
        </f7-col>
        <f7-col class="col-min-width">
          <f7-row>
            <f7-col>
              <div class="label-strong">{{ this.$t('phone') }}</div>
              <div class="item-title-bold value-text">
                {{ OfferSummaryV3.Telefono }}
              </div>
            </f7-col>
          </f7-row>
        </f7-col>
        <f7-col class="col-medium-width">
          <f7-row>
            <f7-col>
              <div class="label-strong">{{ this.$t('status') }}</div>

              <div
                :class="
                  $helpers.getStatusClass(
                    detallesPresupuestosSummary &&
                      detallesPresupuestosSummary.Estado
                  )
                "
                class="status-text"
                style="text-align: left"
              >
                {{ $t(status) }}
              </div>
            </f7-col>
          </f7-row>
        </f7-col>
      </f7-row>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { NOTIFY_TIME_LONG } from '@/js/constants';

export default {
  name: 'OfferListSummary',
  components: {},
  // props: {
  //   store: {
  //     type: Array,
  //     default: () => {},
  //   },
  // },
  data() {
    return {
      loading: false,
      estado: '',
    };
  },
  computed: {
    ...mapState('Offers', [
      'detallesPresupuestosSummary',
      'detallesClientePresupuesto',
      'detallesPresupuestos',
      'status',
    ]),
    OfferSummary() {
      return this.detallesPresupuestosSummary;
    },
    OfferSummaryV2() {
      return this.detallesClientePresupuesto;
    },
    OfferSummaryV3() {
      if (
        this.detallesPresupuestosSummary &&
        this.detallesClientePresupuesto
      ) {
        const codAddress =
          this.detallesPresupuestosSummary.CodDireccion;
        const foundAddress =
          this.detallesClientePresupuesto.Direcciones.find(
            (address) => address.CodDireccion === codAddress
          );
        return foundAddress || 'Not found';
      }
      return 'Not found';
    },
    OfferSummaryV4() {
      if (
        this.detallesPresupuestosSummary &&
        this.detallesClientePresupuesto
      ) {
        const codContact =
          this.detallesPresupuestosSummary.CodContacto;
        const foundContact =
          this.detallesClientePresupuesto.Contactos.find(
            (contact) => contact.CodContacto === codContact
          );
        return foundContact || 'Not found';
      }
      return 'Not found';
    },
  },
  // async beforeMount() {
  //   await this.formatStatus();
  // },
  async mounted() {
    try {
      await this.fetchDetallesPresupuestosSummary();
      this.formatStatus2();
      this.loading = true;
    } catch (error) {
      this.$notifyDX(
        {
          message: this.$t(
            this.$helpers.getFilteredErrorMessage(error.message)
          ),
          width: 550,
        },
        'error',
        NOTIFY_TIME_LONG
      );
      this.loading = false;
    }
  },
  methods: {
    async formatStatus2() {
      if (this.detallesPresupuestosSummary) {
        this.estado = await this.formatStatusForSummary(
          this.detallesPresupuestosSummary.Estado
        );
      }
      return this.estado;
    },
    ...mapActions('Offers', [
      'fetchDetallesPresupuestosSummary',
      'formatStatusForSummary',
    ]),
  },
};
</script>
<style scoped>
/* Label (ej: "Código de oferta") */
.label-strong {
  color: var(--Primary-Blue-70, #00346a);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%; /* 19.6px */
}

/* Valor (ej: "QCA-ES250900001") */
.value-text {
  color: var(--Neutral-70, #3e3c44);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
}

.tableContainerDetails {
  padding: 16px 24px !important;
  border-radius: 10px;
  background: var(--Neutral-10, #f7f7f8) !important;
  border: 1px solid var(--Neutral-20, #e0e0e0); /* un gris suave para el borde */
}

.col-min-width {
  flex: 1;
  max-width: 130px;
}
.col-medium-width {
  flex: 1;
  max-width: 180px;
}
.status-text {
  background: transparent !important;
  border: none !important;
  margin: auto;
  max-width: 100%;
}
</style>
